import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ListingComp, ListingCompTable } from 'app/components';
import { API } from 'app/services';
import { snakeToTitle, useAsyncTask } from 'app/utils';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {},
  card: {
    marginTop: theme.spacing(1),
  },
}));

const headers = ['Screening ID', 'Case', 'Ongoing', 'Created date', 'Screening type', 'Status'];

const filterOptions = {
  sort: true,
  search: true,
  dateRange: true,
  type: true,
  status: true,
  clear: true,
};

const extraOptions = {};

let mounted = false;
const ScreeningListComp = (props) => {
  const {
    status,
    showPaginator = true,
    // eslint-disable-next-line no-unused-vars
    showCheckbox = true,
    showFilter = true,
    // eslint-disable-next-line no-unused-vars
    full = true,
    limit = 10,
    ExtraAction,
    children,
    className,
    routeType = 'account',
    ...rest
  } = props;
  const classes = useStyles();
  const [errorCatcher] = useAsyncTask('loadScreening');
  const [screenings, setScreenings] = useState([]);
  const [filter, setFilter] = useState({ limit, offset: 0 });
  const loadTask = useSelector(({ layout }) => layout.loadingTasks);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    mounted = true;
    return () => (mounted = false);
  }, []);

  const loadScreeningList = (newFilter = filter) => {
    setLoading(true);
    if (!newFilter.status && status) newFilter['status'] = status;
    errorCatcher(async () => {
      const loader = routeType === 'account' ? API.Screening.list_screenings : API.Admin.list_screen;
      const { models, meta } = await loader(newFilter);
      if (mounted) {
        sortListingData(models);

        setFilter({ ...newFilter, count: meta.count });
        setLoading(false);
        setLoaded(true);
      }
    });
  };

  const getScreenDetailPath = (item) => {
    const isRegtank = item.regtank_id !== null;

    if (isRegtank) {
      switch (routeType) {
        case 'admin':
          return `/admin/regtank_screenings/${item.id}/detail`;
        default:
          return `/regtank_screenings/${item.id}/detail`;
      }
    }
    switch (routeType) {
      case 'admin':
        return `/admin/screenings/${item.id}/detail`;
      default:
        return `/screenings/${item.id}/detail`;
    }
  };

  const getCaseDetailPath = (id) => {
    switch (routeType) {
      case 'admin':
        return `/admin/screenings/cases/${id}/detail`;
      default:
        return `/screenings/cases/${id}/detail`;
    }
  };

  const parseType = (type) => {
    switch (type) {
      case 'passport':
        return 'Passport/ID';
      default:
        return snakeToTitle(type);
    }
  };

  const sortListingData = (models) => {
    let allData = [];
    models.forEach((model) => {
      allData.push([
        { label: model.reference, type: 'link', link: getScreenDetailPath(model) },
        { label: model.case?.label, type: 'labelwithlink', link: getCaseDetailPath(model.case?.id), bottomLabel: model.case?.reference },
        { label: model.ongoing_screening, type: 'check' },
        { date: model.created_at, type: 'date' },
        { label: parseType(model.type) },
        { label: model.status, statusType: 'Screen', type: 'status' },
      ]);
    });

    setScreenings(allData);
  };

  return (
    <Box {...rest} className={clsx(classes.root, className)}>
      <ListingComp
        filter={filter}
        setFilter={setFilter}
        showFilter={showFilter}
        ExtraAction={ExtraAction}
        loaded={loaded}
        showPaginator={showPaginator}
        loading={loading || loadTask['loadScreening']}
        filterOptions={filterOptions}
        extraOptions={extraOptions}
        reloadFunc={loadScreeningList}
        setLoading={setLoading}
        searchByText={'Screening ID'}
        dateKey="date">
        {screenings.length > 0 && <ListingCompTable headers={headers} data={screenings} />}
      </ListingComp>
    </Box>
  );
};

export default ScreeningListComp;
